import { useTranslations } from 'next-intl'

import { TaxReceiptType } from '@/entities/user'

export const useTaxReceiptTypeMap = () => {
  const t = useTranslations('receipt_information')

  const TAX_RECEIPT_TYPE_MAP = {
    [TaxReceiptType.CASH_RECEIPT_PERSONAL]: t('type.cash_receipt'),
    [TaxReceiptType.CASH_RECEIPT_BUSINESS]: t('type.cash_receipt'),
    [TaxReceiptType.TAX_INVOICE]: t('type.tax_invoice'),
  }

  return { TAX_RECEIPT_TYPE_MAP }
}
